import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  class: '',
  school: '',
  totalMarks: 80,
  scores: [
    { test: "LISTENING TEST", rightAnswer: 0, wrongAnswer: 0, TotalQue: 0, Percentage : 0},
    { test: "SPEAKING TEST", rightAnswer: 0, wrongAnswer: 0, TotalQue: 0 ,Percentage: 0},
    { test: "READING TEST", rightAnswer: 0, wrongAnswer: 0, TotalQue: 0 , Percentage:0},
    { test: "WRITING TEST", rightAnswer: 0, wrongAnswer: 0, TotalQue: 0, Percentage:0 }
  ],
  result: {
    totalScored: 50,
    totalPossibleMarks: 80,
    overallPercentage: "62.5%",
    status: "Passed"
  }
};

const resultSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    // Updates basic details (name, class, school)
    updateResult(state, action) {
      state.name = action.payload.name;
      state.class = action.payload.class;
      state.school = action.payload.school;
    },

    // Updates score for a specific test
    updateScore(state, action) {
      const { testIndex, rightAnswer, wrongAnswer, TotalQue } = action.payload;
      if (state.scores[testIndex]) {
        state.scores[testIndex].rightAnswer = rightAnswer ?? state.scores[testIndex].rightAnswer;
        state.scores[testIndex].wrongAnswer = wrongAnswer ?? state.scores[testIndex].wrongAnswer;
        state.scores[testIndex].TotalQue = TotalQue ?? state.scores[testIndex].TotalQue;
        state.scores[testIndex].Percentage = ((rightAnswer/TotalQue)*100).toFixed(2);
      }
    },
    AnswerResult(state,action){
      const { testIndex } = action.payload;
      const score = state.scores[testIndex];

       state.scores[testIndex].rightAnswer +=1;
       console.log('answerresult',action);
      console.log("✅ AFTER ANSWER:", JSON.parse(JSON.stringify(state.scores)));
    },
    NoanswerResult(state,action){
      const { testIndex } = action.payload;
       state.scores[testIndex].wrongAnswer +=1;
       console.log("✅ AFTER NOANSWER:", JSON.parse(JSON.stringify(state.scores)));
    },

    // Updates overall result (totalScored, percentage, and status)
    updateOverallResult(state) {
      const totalScored = state.scores.reduce(
        (sum, score) => sum + score.rightAnswer,
        0
      );
      const totalPossibleMarks = state.scores.reduce(
        (sum, score) => sum + score.TotalQue,
        0
      );
      const overallPercentage = ((totalScored / totalPossibleMarks) * 100).toFixed(2);

      state.result.totalScored = totalScored;
      state.result.totalPossibleMarks = totalPossibleMarks;
      state.result.overallPercentage = `${overallPercentage}%`;
      state.result.status = overallPercentage >= 50 ? "Passed" : "Failed";
    }
  }
});

export const { updateResult, updateScore, updateOverallResult,AnswerResult,NoanswerResult } = resultSlice.actions;

export default resultSlice.reducer;
